import React, { useState } from "react";
import TableCompo from "../Table/TableCompo";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Box } from "@mui/material";
import { fetchMetals } from "../../../redux/slices/metalRateSlice";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Divider, Button } from "@mui/material";
import { useEffect } from "react";
import moment from "moment";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import useCsvConverter from "../../../hooks/convertToCSV";
import { getMetalHistory } from "../../../redux/slices/manageMetals";
import { render } from "@testing-library/react";

const MetalBalanceHistory = ({ list = [], total = 0 }) => {
  const dispatch = useDispatch();
  const { convertToCsv } = useCsvConverter();

  const decimal = useSelector(
        (state) => state?.appConfig?.configData?.decimalPrecision || 4,
      );

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    dispatch(
      getMetalHistory({
        page: page + 1,
        limit: limit,
        search: searchText,
      }),
    );
  }, [page, limit, searchText]);

  const handleTableChange = (type, payload) => {
    if (type === "changePage") {
      setPage(payload.page);
    }
    if (type === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }

    if (type === "search") {
      setSearchText(payload.searchText);
      setPage(0);
    }
  };

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadStoreCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/metal-balance/metalBalanceHistoryCsv",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "metalBalanceHistory.csv");
        },
      }),
    );
  };

  const columns = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: "metalName", headerName: "METAL NAME", width: 150 },
    {
      field: "purity",
      render: (value, row) => (
        <>
          {row?.bullion?.karat}k-{row?.bullion?.purity}
        </>
      ),
      headerName: "PURITY",
      width: 100,
    },
    {
      field: "hsnCode",
      render: (value, row) => <>{row?.bullion?.hsnCode}</>,
      headerName: "Hsn Code",
      width: 120,
    },
    { field: "weight",
       headerName: "Weight",
      render: (value, row) =>
        row?.weight !== undefined && row?.weight !== null
          ? Number(row.weight).toFixed(decimal)
          : "0",
       width: 150 },
    {
      field: "availableBalance",
      headerName: "Available Balance",
      render: (params, row) => (
        <div
          style={{
            backgroundColor: row.type == "UPDATE" ? "yellow" : "green",
            color: row.type == "UPDATE" ? "black" : "white",
            width: "100%",
            height: "100%",
            padding: "8px",
          }}
        >
          {row?.availableBalance !== undefined && row?.availableBalance !== null
            ? Number(row.availableBalance).toFixed(decimal)
            : "0"}
        </div>
      ),
      width: 100,
    },
    {
      field: "till",
      headerName: "Till",
      render: (value, row) => (
        <>{row.till ? moment(row?.till).format("DD-MM-YYYY hh:mm A") : "0"}</>
      ),
      width: 150,
    },
    {
      field: "type",
      headerName: "Type",
      width: 150,
      render: (params, row) => (
        <div
          style={{
            backgroundColor:
              row.type == "UPDATE"
                ? "yellow"
                : row.type == "REMOVE"
                  ? "red"
                  : "green",
            color: row.type == "UPDATE" ? "black" : "white",
            width: "100%",
            height: "100%",
            padding: "8px",
          }}
        >
          {row.type}
        </div>
      ),
    },
    {
      field: "orderType",
      render: (value, row) => <>{row?.orderType || "N.A"}</>,
      headerName: "Order Type",
      width: 150,
    },
    {
      field: "transactionType",
      render: (value, row) => <>{row?.transactionType || "N.A"}</>,
      headerName: "Transaction Type",
      width: 200,
    },
    {
      field: 'name',
      render: (value, row) => (
        <>
          {row?.customer
            ? `${row.customer.firstName ?? ''} ${row.customer.lastName ?? ''}`.trim() ||
              'N.A'
            : 'N.A'}
        </>
      ),
      headerName: 'Customer',
      width: 200,
    },
    {
      field: "username",
      render: (value, row) => <>{row?.user?.name || "N.A"}</>,
      headerName: "User",
      width: 200,
    },
  ];

  return (
    <Box>
      <TableCompo
        columns={columns}
        data={list}
        page={page}
        limit={limit}
        totalCount={total}
        onTableChange={handleTableChange}
        extraButtons={
          <Button size="sm" variant="outlined" onClick={handleDownloadStoreCsv}>
            Download CSV
          </Button>
        }
      />
    </Box>
  );
};

export default MetalBalanceHistory;
